export const REPLACEMENT_THRESHOLD = () => {
  const getReplacementThresholdConfig = (key, min, max, mandatory) => ({
    key,
    minValue: min,
    maxValue: max,
    mandatory,
  });

  return {
    max_feed_pressure: getReplacementThresholdConfig(
      "max_feed_pressure",
      0,
      null,
      true
    ),
    max_permeate_quality: getReplacementThresholdConfig(
      "max_permeate_quality",
      0,
      null,
      true
    ),
    std_warranty_period: getReplacementThresholdConfig(
      "std_warranty_period",
      0,
      null,
      true
    ),
    startup_pressure_drop: getReplacementThresholdConfig(
      "startup_pressure_drop",
      0,
      null
    ),
    designed_permeate_flow: getReplacementThresholdConfig(
      "designed_permeate_flow",
      0,
      null,
      true
    ),
    std_membrane_age: getReplacementThresholdConfig(
      "std_membrane_age",
      0,
      null,
      true
    ),
    max_pressure_drop: getReplacementThresholdConfig(
      "max_pressure_drop",
      0,
      100,
      true
    ),
    min_permeate_flow: getReplacementThresholdConfig(
      "min_permeate_flow",
      0,
      null
    )
  };
};
